<template>
    <div class="save-status">
        <autosave-status v-if="isSuccess || isSaving" :saving="isSaving" />

        <ds-status
            v-else-if="isFailed"
            type="error"
            emphasis="medium"
            data-qa="save-failed"
        >
            Save failed
        </ds-status>
    </div>
</template>

<script>
import AutosaveStatus from '@/components/shared/AutosaveStatus';
import { SAVE_STATUS } from '@/components/automations/constants/automations.constants';

export default {
    components: {
        AutosaveStatus,
    },

    props: {
        status: String,
    },

    computed: {
        isSaving() {
            return this.status === SAVE_STATUS.SAVING;
        },

        isSuccess() {
            return this.status === SAVE_STATUS.SUCCESS;
        },

        isFailed() {
            return this.status === SAVE_STATUS.FAILED;
        },
    },
};
</script>

<style lang="scss" scoped>
.save-status {
    font-size: $font-size-sm;
}
</style>
